import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Email: { input: any; output: any; }
  ImageFile: { input: any; output: any; }
  Violation: { input: any; output: any; }
  frameFile: { input: any; output: any; }
};

export enum AddFramesDirection {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type Animation = {
  __typename?: 'Animation';
  alignmentData?: Maybe<Scalars['String']['output']>;
  alignmentLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alignmentROIsIndex?: Maybe<Scalars['Int']['output']>;
  animationType?: Maybe<AnimationType>;
  caption?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Copyright>;
  copyrightUrl?: Maybe<Scalars['String']['output']>;
  h?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  stillFrameStem?: Maybe<Scalars['String']['output']>;
  subDir?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
};

export type AnimationAddFramesInput = {
  autoPublishPanel?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<AddFramesDirection>;
  frames: Array<Scalars['frameFile']['input']>;
};

export type AnimationCreateInput = {
  alignmentLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  animationType?: InputMaybe<AnimationType>;
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['Int']['input']>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  frames: Array<Scalars['frameFile']['input']>;
  maskROIs: Scalars['String']['input'];
  subDir?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AnimationPanelInput = {
  animation?: InputMaybe<AnimationCreateInput>;
  delta?: InputMaybe<Scalars['Int']['input']>;
  panel?: InputMaybe<PanelInput>;
};

export type AnimationResponse = {
  __typename?: 'AnimationResponse';
  animation?: Maybe<Animation>;
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
};

export enum AnimationType {
  Basic = 'BASIC'
}

export type AnimationUpdateInput = {
  alignmentLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignmentROIsIndex?: InputMaybe<Scalars['Int']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['Int']['input']>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  stillFrameStem?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<AnnotationVariant>;
};

export enum AnnotationVariant {
  Caption = 'CAPTION',
  Comment = 'COMMENT',
  Elucidation = 'ELUCIDATION',
  Footnote = 'FOOTNOTE',
  Note = 'NOTE',
  Remark = 'REMARK'
}

export type BannerPhotoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  photo?: InputMaybe<PhotoInput>;
};

export type Cluster = {
  __typename?: 'Cluster';
  access?: Maybe<Scalars['Boolean']['output']>;
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  changed?: Maybe<Scalars['Date']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  owner?: Maybe<User>;
  panels?: Maybe<Array<Maybe<Panel>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  shape?: Maybe<ClusterShape>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type ClusterConnection = {
  __typename?: 'ClusterConnection';
  items?: Maybe<Array<Cluster>>;
  total: Scalars['Int']['output'];
};

export type ClusterInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  adminTitle?: InputMaybe<Scalars['String']['input']>;
  publishAll?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  removePanelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shape?: InputMaybe<ClusterShape>;
  sortedPanelIds: Array<Scalars['Int']['input']>;
};

export type ClusterResponse = Response & {
  __typename?: 'ClusterResponse';
  cluster?: Maybe<Cluster>;
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
};

export enum ClusterShape {
  Float = 'FLOAT',
  Grid = 'GRID',
  Placeholder = 'PLACEHOLDER',
  Strip = 'STRIP'
}

export type ContactInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  privacyAccepted: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ContactResponse = Response & {
  __typename?: 'ContactResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  submission?: Maybe<ContactSubmission>;
};

export type ContactSubmission = {
  __typename?: 'ContactSubmission';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Copyright = {
  __typename?: 'Copyright';
  copyrightType?: Maybe<CopyrightType>;
  copyrightUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CopyrightConnection = {
  __typename?: 'CopyrightConnection';
  items?: Maybe<Array<Maybe<Copyright>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CopyrightInput = {
  copyrightType?: InputMaybe<CopyrightType>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CopyrightResponse = Response & {
  __typename?: 'CopyrightResponse';
  copyright?: Maybe<Copyright>;
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
};

export enum CopyrightType {
  Copyleft = 'COPYLEFT',
  Copyright = 'COPYRIGHT',
  PublicDomain = 'PUBLIC_DOMAIN',
  SoundRecording = 'SOUND_RECORDING'
}

export type CreateClusterInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  adminTitle?: InputMaybe<Scalars['String']['input']>;
  delta?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatrixInput = {
  bannerPhoto?: InputMaybe<BannerPhotoInput>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  delta?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<MatrixKind>;
  leadText?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<MatrixStructure>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateZoneInput = {
  bannerPhoto?: InputMaybe<BannerPhotoInput>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  delta?: InputMaybe<Scalars['Int']['input']>;
  matrix?: InputMaybe<CreateMatrixInput>;
  pathId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteResponse = Response & {
  __typename?: 'DeleteResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  success?: Maybe<Success>;
};

export type Diagram = {
  __typename?: 'Diagram';
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type Drawing = {
  __typename?: 'Drawing';
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type Matrix = {
  __typename?: 'Matrix';
  access?: Maybe<Scalars['Boolean']['output']>;
  bannerPhoto?: Maybe<Array<Maybe<Photo>>>;
  bannerText?: Maybe<Scalars['String']['output']>;
  canonicalZone?: Maybe<Array<Maybe<Zone>>>;
  changed?: Maybe<Scalars['Date']['output']>;
  clusters?: Maybe<Array<Maybe<Cluster>>>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  kind?: Maybe<MatrixKind>;
  lastmod?: Maybe<Scalars['Int']['output']>;
  leadText?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  pathId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['Date']['output']>;
  publishedLocked?: Maybe<Scalars['Boolean']['output']>;
  structure?: Maybe<MatrixStructure>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MatrixConnection = {
  __typename?: 'MatrixConnection';
  items?: Maybe<Array<Matrix>>;
  total: Scalars['Int']['output'];
};

export type MatrixInput = {
  autoUpdatePathId?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhoto?: InputMaybe<BannerPhotoInput>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  canonicalNodeId?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<MatrixKind>;
  leadText?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['String']['input']>;
  publishAll?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  removeClusterIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortedClusterIds: Array<Scalars['Int']['input']>;
  structure?: InputMaybe<MatrixStructure>;
  title?: InputMaybe<Scalars['String']['input']>;
  unlinkClusterIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum MatrixKind {
  Fixed = 'FIXED',
  Floating = 'FLOATING',
  Loose = 'LOOSE',
  Random = 'RANDOM'
}

export type MatrixResponse = Response & {
  __typename?: 'MatrixResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  matrix?: Maybe<Matrix>;
};

export enum MatrixStructure {
  Grid = 'GRID',
  GridSystem = 'GRID_SYSTEM',
  Panorama = 'PANORAMA',
  Scroll = 'SCROLL'
}

export type Mutation = {
  __typename?: 'Mutation';
  animationAddFrames?: Maybe<SuccessResponse>;
  animationUpdate?: Maybe<AnimationResponse>;
  createClusterAnimationPanel?: Maybe<ClusterResponse>;
  createClusterPhotoPanel?: Maybe<ClusterResponse>;
  createClusterTextPanel?: Maybe<ClusterResponse>;
  createCopyright?: Maybe<CopyrightResponse>;
  createMatrixCluster?: Maybe<MatrixResponse>;
  createPhoto?: Maybe<PhotoResponse>;
  createRealmZone?: Maybe<RealmResponse>;
  createZoneMatrix?: Maybe<ZoneResponse>;
  deletePhoto?: Maybe<DeleteResponse>;
  sendContactEmail?: Maybe<ContactResponse>;
  updateCluster?: Maybe<ClusterResponse>;
  updateMatrix?: Maybe<MatrixResponse>;
  updatePanel?: Maybe<PanelResponse>;
  updatePhoto?: Maybe<PhotoResponse>;
  updateRealm?: Maybe<RealmResponse>;
  updateText?: Maybe<TextResponse>;
  updateZone?: Maybe<ZoneResponse>;
};


export type MutationAnimationAddFramesArgs = {
  data?: InputMaybe<AnimationAddFramesInput>;
  id: Scalars['Int']['input'];
};


export type MutationAnimationUpdateArgs = {
  data?: InputMaybe<AnimationUpdateInput>;
  id: Scalars['Int']['input'];
};


export type MutationCreateClusterAnimationPanelArgs = {
  clusterId: Scalars['Int']['input'];
  data?: InputMaybe<AnimationPanelInput>;
};


export type MutationCreateClusterPhotoPanelArgs = {
  clusterId: Scalars['Int']['input'];
  data?: InputMaybe<PhotoPanelInput>;
};


export type MutationCreateClusterTextPanelArgs = {
  clusterId: Scalars['Int']['input'];
  data?: InputMaybe<TextPanelInput>;
};


export type MutationCreateCopyrightArgs = {
  data?: InputMaybe<CopyrightInput>;
};


export type MutationCreateMatrixClusterArgs = {
  data?: InputMaybe<CreateClusterInput>;
  matrixId: Scalars['Int']['input'];
};


export type MutationCreatePhotoArgs = {
  data?: InputMaybe<PhotoInput>;
};


export type MutationCreateRealmZoneArgs = {
  data?: InputMaybe<CreateZoneInput>;
  realmId: Scalars['Int']['input'];
};


export type MutationCreateZoneMatrixArgs = {
  data?: InputMaybe<CreateMatrixInput>;
  zoneId: Scalars['Int']['input'];
};


export type MutationDeletePhotoArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendContactEmailArgs = {
  input: ContactInput;
};


export type MutationUpdateClusterArgs = {
  clusterId: Scalars['Int']['input'];
  data?: InputMaybe<ClusterInput>;
};


export type MutationUpdateMatrixArgs = {
  data?: InputMaybe<MatrixInput>;
  matrixId: Scalars['Int']['input'];
};


export type MutationUpdatePanelArgs = {
  data?: InputMaybe<PanelInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePhotoArgs = {
  data?: InputMaybe<PhotoInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateRealmArgs = {
  data?: InputMaybe<RealmInput>;
  realmId: Scalars['Int']['input'];
};


export type MutationUpdateTextArgs = {
  data?: InputMaybe<TextInput>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateZoneArgs = {
  data?: InputMaybe<ZoneInput>;
  zoneId: Scalars['Int']['input'];
};

export type Panel = {
  __typename?: 'Panel';
  access?: Maybe<Scalars['Boolean']['output']>;
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  animation?: Maybe<Array<Maybe<Animation>>>;
  annotations?: Maybe<Array<Maybe<Annotation>>>;
  changed?: Maybe<Scalars['Date']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  diagram?: Maybe<Array<Maybe<Diagram>>>;
  drawing?: Maybe<Array<Maybe<Drawing>>>;
  id: Scalars['Int']['output'];
  owner?: Maybe<User>;
  photo?: Maybe<Array<Maybe<Photo>>>;
  published?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  text?: Maybe<Array<Maybe<Text>>>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
  z?: Maybe<Scalars['Int']['output']>;
};

export type PanelInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  adminTitle?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
  z?: InputMaybe<Scalars['Int']['input']>;
};

export type PanelResponse = Response & {
  __typename?: 'PanelResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  panel?: Maybe<Panel>;
};

export type Photo = {
  __typename?: 'Photo';
  caption?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Copyright>;
  copyrightUrl?: Maybe<Scalars['String']['output']>;
  fileChanged?: Maybe<Scalars['String']['output']>;
  h?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Tag>>>;
  url?: Maybe<Scalars['String']['output']>;
  w?: Maybe<Scalars['Int']['output']>;
};

export type PhotoInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['Int']['input']>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
  imageFile?: InputMaybe<Scalars['ImageFile']['input']>;
};

export type PhotoPanelInput = {
  delta?: InputMaybe<Scalars['Int']['input']>;
  panel?: InputMaybe<PanelInput>;
  photo?: InputMaybe<PhotoInput>;
};

export type PhotoResponse = Response & {
  __typename?: 'PhotoResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  photo?: Maybe<Photo>;
};

export type Query = {
  __typename?: 'Query';
  animation?: Maybe<Animation>;
  cluster?: Maybe<Cluster>;
  clusters: ClusterConnection;
  copyright?: Maybe<Copyright>;
  copyrights?: Maybe<CopyrightConnection>;
  diagram?: Maybe<Diagram>;
  drawing?: Maybe<Drawing>;
  globalLastmod?: Maybe<Scalars['Int']['output']>;
  matrices: MatrixConnection;
  matrix?: Maybe<Matrix>;
  panel?: Maybe<Panel>;
  photo?: Maybe<Photo>;
  realm?: Maybe<Realm>;
  realms: RealmConnection;
  tag?: Maybe<Tag>;
  text?: Maybe<Text>;
  textEdit?: Maybe<TextEdit>;
  user?: Maybe<User>;
  userCurrent?: Maybe<User>;
  zone?: Maybe<Zone>;
  zones: ZoneConnection;
};


export type QueryAnimationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClusterArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClustersArgs = {
  idList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCopyrightArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiagramArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatricesArgs = {
  idList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatrixArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPanelArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPhotoArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRealmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRealmsArgs = {
  idList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTextArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTextEditArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryZoneArgs = {
  id: Scalars['Int']['input'];
};


export type QueryZonesArgs = {
  idList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Realm = {
  __typename?: 'Realm';
  access?: Maybe<Scalars['Boolean']['output']>;
  bannerPhoto?: Maybe<Array<Maybe<Photo>>>;
  bannerText?: Maybe<Scalars['String']['output']>;
  changed?: Maybe<Scalars['Date']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lastmod?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  pathId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedLocked?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

export type RealmConnection = {
  __typename?: 'RealmConnection';
  items?: Maybe<Array<Realm>>;
  total: Scalars['Int']['output'];
};

export type RealmInput = {
  autoUpdatePathId?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhoto?: InputMaybe<BannerPhotoInput>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['String']['input']>;
  publishAll?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  removeZoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortedZoneIds: Array<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unlinkZoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RealmResponse = Response & {
  __typename?: 'RealmResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  realm?: Maybe<Realm>;
};

export type Response = {
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
};

export type Success = {
  __typename?: 'Success';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SuccessResponse = Response & {
  __typename?: 'SuccessResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  success?: Maybe<Success>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Text = {
  __typename?: 'Text';
  id: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type TextEdit = {
  __typename?: 'TextEdit';
  adminNote?: Maybe<Scalars['String']['output']>;
  adminTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Tag>>>;
  textJson?: Maybe<Scalars['String']['output']>;
};

export type TextInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  adminTitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textJson?: InputMaybe<Scalars['String']['input']>;
};

export type TextPanelInput = {
  delta?: InputMaybe<Scalars['Int']['input']>;
  panel?: InputMaybe<PanelInput>;
  text?: InputMaybe<TextInput>;
};

export type TextResponse = Response & {
  __typename?: 'TextResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  text?: Maybe<Text>;
  textEdit?: Maybe<TextEdit>;
};

export type User = {
  __typename?: 'User';
  created?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<UserRole>>;
  updated?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum UserRole {
  Administrator = 'administrator',
  Anonymous = 'anonymous',
  Authenticated = 'authenticated',
  ContentAdministrator = 'content_administrator',
  ContentAuthor = 'content_author',
  ContentManager = 'content_manager',
  ContentMentor = 'content_mentor'
}

export type Zone = {
  __typename?: 'Zone';
  access?: Maybe<Scalars['Boolean']['output']>;
  bannerPhoto?: Maybe<Array<Maybe<Photo>>>;
  bannerText?: Maybe<Scalars['String']['output']>;
  canonicalRealm?: Maybe<Array<Maybe<Realm>>>;
  changed?: Maybe<Scalars['Date']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  lastmod?: Maybe<Scalars['Int']['output']>;
  matrices?: Maybe<Array<Maybe<Matrix>>>;
  owner?: Maybe<User>;
  pathId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedLocked?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ZoneConnection = {
  __typename?: 'ZoneConnection';
  items?: Maybe<Array<Zone>>;
  total: Scalars['Int']['output'];
};

export type ZoneInput = {
  autoUpdatePathId?: InputMaybe<Scalars['Boolean']['input']>;
  bannerPhoto?: InputMaybe<BannerPhotoInput>;
  bannerText?: InputMaybe<Scalars['String']['input']>;
  canonicalNodeId?: InputMaybe<Scalars['Int']['input']>;
  pathId?: InputMaybe<Scalars['String']['input']>;
  publishAll?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  removeMatrixIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortedMatrixIds: Array<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unlinkMatrixIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ZoneResponse = Response & {
  __typename?: 'ZoneResponse';
  debug?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['Violation']['output']>>>;
  zone?: Maybe<Zone>;
};

export type GetNavQueryVariables = Exact<{
  isContentEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNavQuery = { __typename?: 'Query', realms: { __typename?: 'RealmConnection', items?: Array<{ __typename?: 'Realm', published?: boolean | null, created?: any | null, id: number, pathId?: string | null, title?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string } | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, published?: boolean | null, created?: any | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, published?: boolean | null, created?: any | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, owner?: { __typename?: 'User', id: number, name: string } | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, owner?: { __typename?: 'User', id: number, name: string } | null } | null> | null }> | null } };

export type AnnotationFieldsFragment = { __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null };

export type AnimationAddFramesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: AnimationAddFramesInput;
}>;


export type AnimationAddFramesMutation = { __typename?: 'Mutation', animationAddFrames?: { __typename?: 'SuccessResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, success?: { __typename?: 'Success', success: boolean, message?: string | null } | null } | null };

export type AnimationFieldsFragment = { __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null };

export type AnimationUpdateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: AnimationUpdateInput;
}>;


export type AnimationUpdateMutation = { __typename?: 'Mutation', animationUpdate?: { __typename?: 'AnimationResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, animation?: { __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null } | null };

export type DiagramFieldsFragment = { __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null };

export type DrawingFieldsFragment = { __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null };

export type CreatePhotoMutationVariables = Exact<{
  caption?: InputMaybe<Scalars['String']['input']>;
  imageFile?: InputMaybe<Scalars['ImageFile']['input']>;
  copyright: Scalars['Int']['input'];
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePhotoMutation = { __typename?: 'Mutation', createPhoto?: { __typename?: 'PhotoResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, photo?: { __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null } | null };

export type DeletePhotoMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePhotoMutation = { __typename?: 'Mutation', deletePhoto?: { __typename?: 'DeleteResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, success?: { __typename?: 'Success', success: boolean, message?: string | null } | null } | null };

export type PhotoFieldsFragment = { __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null };

export type UpdatePhotoMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  caption: Scalars['String']['input'];
  imageFile?: InputMaybe<Scalars['ImageFile']['input']>;
  copyright: Scalars['Int']['input'];
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePhotoMutation = { __typename?: 'Mutation', updatePhoto?: { __typename?: 'PhotoResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, photo?: { __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null } | null };

export type GetTextEditQueryVariables = Exact<{
  textId: Scalars['Int']['input'];
}>;


export type GetTextEditQuery = { __typename?: 'Query', textEdit?: { __typename?: 'TextEdit', id: number, adminTitle?: string | null, adminNote?: string | null, textJson?: string | null } | null };

export type TextEditFieldsFragment = { __typename?: 'TextEdit', id: number, adminTitle?: string | null, adminNote?: string | null, textJson?: string | null };

export type TextFieldsFragment = { __typename?: 'Text', id: number, text?: string | null };

export type UpdateTextMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  adminTitle: Scalars['String']['input'];
  adminNote?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textJson?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTextMutation = { __typename?: 'Mutation', updateText?: { __typename?: 'TextResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, text?: { __typename?: 'Text', id: number, text?: string | null } | null, textEdit?: { __typename?: 'TextEdit', id: number, adminTitle?: string | null, adminNote?: string | null, textJson?: string | null } | null } | null };

export type SendContactEmailMutationVariables = Exact<{
  input: ContactInput;
}>;


export type SendContactEmailMutation = { __typename?: 'Mutation', sendContactEmail?: { __typename?: 'ContactResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, submission?: { __typename?: 'ContactSubmission', success: boolean, message?: string | null } | null } | null };

export type GetClusterQueryVariables = Exact<{
  clusterId: Scalars['Int']['input'];
}>;


export type GetClusterQuery = { __typename?: 'Query', cluster?: { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null };

export type ClusterFieldsFragment = { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null };

export type CreateClusterAnimationPanelMutationVariables = Exact<{
  clusterId: Scalars['Int']['input'];
  data?: InputMaybe<AnimationPanelInput>;
}>;


export type CreateClusterAnimationPanelMutation = { __typename?: 'Mutation', createClusterAnimationPanel?: { __typename?: 'ClusterResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, cluster?: { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null } | null };

export type CreateClusterPhotoPanelMutationVariables = Exact<{
  clusterId: Scalars['Int']['input'];
  delta?: InputMaybe<Scalars['Int']['input']>;
  panelAdminTitle?: InputMaybe<Scalars['String']['input']>;
  panelAdminNote?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
  z?: InputMaybe<Scalars['Int']['input']>;
  photoCaption?: InputMaybe<Scalars['String']['input']>;
  photoImageFile?: InputMaybe<Scalars['ImageFile']['input']>;
  photoCopyright?: InputMaybe<Scalars['Int']['input']>;
  photoCopyrightUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClusterPhotoPanelMutation = { __typename?: 'Mutation', createClusterPhotoPanel?: { __typename?: 'ClusterResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, cluster?: { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null } | null };

export type CreateClusterTextPanelMutationVariables = Exact<{
  clusterId: Scalars['Int']['input'];
  delta?: InputMaybe<Scalars['Int']['input']>;
  panelAdminTitle?: InputMaybe<Scalars['String']['input']>;
  panelAdminNote?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
  z?: InputMaybe<Scalars['Int']['input']>;
  textAdminTitle?: InputMaybe<Scalars['String']['input']>;
  textAdminNote?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textJson?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClusterTextPanelMutation = { __typename?: 'Mutation', createClusterTextPanel?: { __typename?: 'ClusterResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, cluster?: { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null } | null };

export type UpdateClusterMutationVariables = Exact<{
  clusterId: Scalars['Int']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  publishAll?: InputMaybe<Scalars['Boolean']['input']>;
  adminTitle: Scalars['String']['input'];
  adminNote?: InputMaybe<Scalars['String']['input']>;
  shape?: InputMaybe<ClusterShape>;
  removePanelIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  sortedPanelIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateClusterMutation = { __typename?: 'Mutation', updateCluster?: { __typename?: 'ClusterResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, cluster?: { __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null } | null };

export type CreateMatrixClusterMutationVariables = Exact<{
  matrixId: Scalars['Int']['input'];
  data: CreateClusterInput;
}>;


export type CreateMatrixClusterMutation = { __typename?: 'Mutation', createMatrixCluster?: { __typename?: 'MatrixResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, matrix?: { __typename?: 'Matrix', id: number, published?: boolean | null, publishedLocked?: boolean | null, publishedDate?: any | null, changed?: any | null, title?: string | null, pathId?: string | null, structure?: MatrixStructure | null, kind?: MatrixKind | null, bannerText?: string | null, leadText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalZone?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, clusters?: Array<{ __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null };

export type GetMatrixQueryVariables = Exact<{
  matrixId: Scalars['Int']['input'];
}>;


export type GetMatrixQuery = { __typename?: 'Query', matrix?: { __typename?: 'Matrix', id: number, published?: boolean | null, publishedLocked?: boolean | null, publishedDate?: any | null, changed?: any | null, title?: string | null, pathId?: string | null, structure?: MatrixStructure | null, kind?: MatrixKind | null, bannerText?: string | null, leadText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalZone?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, clusters?: Array<{ __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type MatrixAdminFieldsFragment = { __typename?: 'Matrix', published?: boolean | null, created?: any | null, owner?: { __typename?: 'User', id: number, name: string } | null };

export type MatrixFieldsFragment = { __typename?: 'Matrix', id: number, published?: boolean | null, publishedLocked?: boolean | null, publishedDate?: any | null, changed?: any | null, title?: string | null, pathId?: string | null, structure?: MatrixStructure | null, kind?: MatrixKind | null, bannerText?: string | null, leadText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalZone?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, clusters?: Array<{ __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null> | null };

export type GetMatrixLiteQueryVariables = Exact<{
  matrixId: Scalars['Int']['input'];
}>;


export type GetMatrixLiteQuery = { __typename?: 'Query', matrix?: { __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null };

export type MatrixLiteFieldsFragment = { __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null };

export type UpdateMatrixMutationVariables = Exact<{
  matrixId: Scalars['Int']['input'];
  data: MatrixInput;
}>;


export type UpdateMatrixMutation = { __typename?: 'Mutation', updateMatrix?: { __typename?: 'MatrixResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, matrix?: { __typename?: 'Matrix', id: number, published?: boolean | null, publishedLocked?: boolean | null, publishedDate?: any | null, changed?: any | null, title?: string | null, pathId?: string | null, structure?: MatrixStructure | null, kind?: MatrixKind | null, bannerText?: string | null, leadText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalZone?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, clusters?: Array<{ __typename?: 'Cluster', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, shape?: ClusterShape | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, panels?: Array<{ __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null> | null } | null> | null } | null } | null };

export type PanelFieldsFragment = { __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null };

export type UpdatePanelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  adminTitle: Scalars['String']['input'];
  adminNote?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
  z?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdatePanelMutation = { __typename?: 'Mutation', updatePanel?: { __typename?: 'PanelResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, panel?: { __typename?: 'Panel', id: number, published?: boolean | null, adminTitle?: string | null, adminNote?: string | null, x?: number | null, y?: number | null, z?: number | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, annotations?: Array<{ __typename?: 'Annotation', id: number, adminTitle?: string | null, adminNote?: string | null, variant?: AnnotationVariant | null, text?: string | null } | null> | null, animation?: Array<{ __typename?: 'Animation', id: number, title?: string | null, caption?: string | null, subDir?: string | null, animationType?: AnimationType | null, alignmentData?: string | null, alignmentLabels?: Array<string | null> | null, alignmentROIsIndex?: number | null, stillFrameStem?: string | null, w?: number | null, h?: number | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, diagram?: Array<{ __typename?: 'Diagram', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, drawing?: Array<{ __typename?: 'Drawing', id: number, adminTitle?: string | null, adminNote?: string | null } | null> | null, photo?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, text?: Array<{ __typename?: 'Text', id: number, text?: string | null } | null> | null } | null } | null };

export type CreateRealmZoneMutationVariables = Exact<{
  realmId: Scalars['Int']['input'];
  data: CreateZoneInput;
}>;


export type CreateRealmZoneMutation = { __typename?: 'Mutation', createRealmZone?: { __typename?: 'RealmResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, realm?: { __typename?: 'Realm', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type GetRealmQueryVariables = Exact<{
  realmId: Scalars['Int']['input'];
}>;


export type GetRealmQuery = { __typename?: 'Query', realm?: { __typename?: 'Realm', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null };

export type RealmCanonicalFieldsFragment = { __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null };

export type RealmFieldsFragment = { __typename?: 'Realm', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null };

export type UpdateRealmMutationVariables = Exact<{
  realmId: Scalars['Int']['input'];
  data: RealmInput;
}>;


export type UpdateRealmMutation = { __typename?: 'Mutation', updateRealm?: { __typename?: 'RealmResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, realm?: { __typename?: 'Realm', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type CreateZoneMatrixMutationVariables = Exact<{
  zoneId: Scalars['Int']['input'];
  data: CreateMatrixInput;
}>;


export type CreateZoneMatrixMutation = { __typename?: 'Mutation', createZoneMatrix?: { __typename?: 'ZoneResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type UpdateZoneMutationVariables = Exact<{
  zoneId: Scalars['Int']['input'];
  data: ZoneInput;
}>;


export type UpdateZoneMutation = { __typename?: 'Mutation', updateZone?: { __typename?: 'ZoneResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type GetZoneQueryVariables = Exact<{
  zoneId: Scalars['Int']['input'];
}>;


export type GetZoneQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null } | null };

export type ZoneAdminFieldsFragment = { __typename?: 'Zone', published?: boolean | null, created?: any | null, owner?: { __typename?: 'User', id: number, name: string } | null };

export type ZoneCanonicalFieldsFragment = { __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null };

export type ZoneFieldsFragment = { __typename?: 'Zone', id: number, published?: boolean | null, publishedLocked?: boolean | null, title?: string | null, pathId?: string | null, bannerText?: string | null, owner?: { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null } | null, canonicalRealm?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null } | null> | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, leadText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null> | null };

export type GetZoneLiteQueryVariables = Exact<{
  zoneId: Scalars['Int']['input'];
}>;


export type GetZoneLiteQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null } | null };

export type ZoneLiteFieldsFragment = { __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, bannerText?: string | null, bannerPhoto?: Array<{ __typename?: 'Photo', id: number, caption?: string | null, url?: string | null, w?: number | null, h?: number | null, fileChanged?: string | null, copyrightUrl?: string | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null> | null };

export type GetUserCurrentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrentQuery = { __typename?: 'Query', userCurrent?: { __typename?: 'User', id: number, uuid?: string | null, name: string, email?: any | null, created?: number | null, updated?: number | null, roles?: Array<UserRole> | null } | null };

export type UserFieldsFragment = { __typename?: 'User', id: number, name: string, email?: any | null, roles?: Array<UserRole> | null };

export type CopyrightFieldsFragment = { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null };

export type CreateCopyrightMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  copyrightType?: InputMaybe<CopyrightType>;
  copyrightUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCopyrightMutation = { __typename?: 'Mutation', createCopyright?: { __typename?: 'CopyrightResponse', errors?: Array<any | null> | null, debug?: Array<string | null> | null, copyright?: { __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null } | null };

export type GetCopyrightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCopyrightsQuery = { __typename?: 'Query', copyrights?: { __typename?: 'CopyrightConnection', total?: number | null, items?: Array<{ __typename?: 'Copyright', id: number, name?: string | null, copyrightType?: CopyrightType | null, copyrightUrl?: string | null } | null> | null } | null };

export type GetSitemapRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitemapRoutesQuery = { __typename?: 'Query', globalLastmod?: number | null, realms: { __typename?: 'RealmConnection', items?: Array<{ __typename?: 'Realm', id: number, title?: string | null, pathId?: string | null, lastmod?: number | null, zones?: Array<{ __typename?: 'Zone', id: number, title?: string | null, pathId?: string | null, lastmod?: number | null, matrices?: Array<{ __typename?: 'Matrix', id: number, title?: string | null, pathId?: string | null, lastmod?: number | null } | null> | null } | null> | null }> | null }, home?: { __typename?: 'Matrix', lastmod?: number | null } | null };

export type SuccessFieldsFragment = { __typename?: 'Success', success: boolean, message?: string | null };

export const TextEditFieldsFragmentDoc = gql`
    fragment TextEditFields on TextEdit {
  id
  adminTitle
  adminNote
  textJson
}
    `;
export const MatrixAdminFieldsFragmentDoc = gql`
    fragment MatrixAdminFields on Matrix {
  published
  created
  owner {
    id
    name
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  name
  email
  roles
}
    `;
export const RealmCanonicalFieldsFragmentDoc = gql`
    fragment RealmCanonicalFields on Realm {
  id
  title
  pathId
}
    `;
export const ZoneCanonicalFieldsFragmentDoc = gql`
    fragment ZoneCanonicalFields on Zone {
  id
  title
  pathId
  canonicalRealm {
    ...RealmCanonicalFields
  }
}
    ${RealmCanonicalFieldsFragmentDoc}`;
export const CopyrightFieldsFragmentDoc = gql`
    fragment CopyrightFields on Copyright {
  id
  name
  copyrightType
  copyrightUrl
}
    `;
export const PhotoFieldsFragmentDoc = gql`
    fragment PhotoFields on Photo {
  id
  caption
  url
  w
  h
  fileChanged
  copyright {
    ...CopyrightFields
  }
  copyrightUrl
}
    ${CopyrightFieldsFragmentDoc}`;
export const AnnotationFieldsFragmentDoc = gql`
    fragment AnnotationFields on Annotation {
  id
  adminTitle
  adminNote
  variant
  text
}
    `;
export const AnimationFieldsFragmentDoc = gql`
    fragment AnimationFields on Animation {
  id
  title
  caption
  subDir
  animationType
  alignmentData
  alignmentLabels
  alignmentROIsIndex
  stillFrameStem
  w
  h
  copyright {
    ...CopyrightFields
  }
  copyrightUrl
}
    ${CopyrightFieldsFragmentDoc}`;
export const DiagramFieldsFragmentDoc = gql`
    fragment DiagramFields on Diagram {
  id
  adminTitle
  adminNote
}
    `;
export const DrawingFieldsFragmentDoc = gql`
    fragment DrawingFields on Drawing {
  id
  adminTitle
  adminNote
}
    `;
export const TextFieldsFragmentDoc = gql`
    fragment TextFields on Text {
  id
  text
}
    `;
export const PanelFieldsFragmentDoc = gql`
    fragment PanelFields on Panel {
  id
  published
  adminTitle
  adminNote
  owner {
    ...UserFields
  }
  x
  y
  z
  annotations {
    ...AnnotationFields
  }
  animation {
    ...AnimationFields
  }
  diagram {
    ...DiagramFields
  }
  drawing {
    ...DrawingFields
  }
  photo {
    ...PhotoFields
  }
  text {
    ...TextFields
  }
}
    ${UserFieldsFragmentDoc}
${AnnotationFieldsFragmentDoc}
${AnimationFieldsFragmentDoc}
${DiagramFieldsFragmentDoc}
${DrawingFieldsFragmentDoc}
${PhotoFieldsFragmentDoc}
${TextFieldsFragmentDoc}`;
export const ClusterFieldsFragmentDoc = gql`
    fragment ClusterFields on Cluster {
  id
  published
  adminTitle
  adminNote
  owner {
    ...UserFields
  }
  shape
  panels {
    ...PanelFields
  }
}
    ${UserFieldsFragmentDoc}
${PanelFieldsFragmentDoc}`;
export const MatrixFieldsFragmentDoc = gql`
    fragment MatrixFields on Matrix {
  id
  published
  publishedLocked
  publishedDate
  changed
  owner {
    ...UserFields
  }
  title
  pathId
  structure
  kind
  canonicalZone {
    ...ZoneCanonicalFields
  }
  bannerText
  bannerPhoto {
    ...PhotoFields
  }
  leadText
  clusters {
    ...ClusterFields
  }
}
    ${UserFieldsFragmentDoc}
${ZoneCanonicalFieldsFragmentDoc}
${PhotoFieldsFragmentDoc}
${ClusterFieldsFragmentDoc}`;
export const ZoneLiteFieldsFragmentDoc = gql`
    fragment ZoneLiteFields on Zone {
  id
  title
  pathId
  bannerText
  bannerPhoto {
    ...PhotoFields
  }
}
    ${PhotoFieldsFragmentDoc}`;
export const RealmFieldsFragmentDoc = gql`
    fragment RealmFields on Realm {
  id
  published
  publishedLocked
  owner {
    ...UserFields
  }
  title
  pathId
  bannerText
  bannerPhoto {
    ...PhotoFields
  }
  zones {
    ...ZoneLiteFields
  }
}
    ${UserFieldsFragmentDoc}
${PhotoFieldsFragmentDoc}
${ZoneLiteFieldsFragmentDoc}`;
export const ZoneAdminFieldsFragmentDoc = gql`
    fragment ZoneAdminFields on Zone {
  published
  created
  owner {
    id
    name
  }
}
    `;
export const MatrixLiteFieldsFragmentDoc = gql`
    fragment MatrixLiteFields on Matrix {
  id
  title
  pathId
  bannerText
  leadText
  bannerPhoto {
    ...PhotoFields
  }
}
    ${PhotoFieldsFragmentDoc}`;
export const ZoneFieldsFragmentDoc = gql`
    fragment ZoneFields on Zone {
  id
  published
  publishedLocked
  owner {
    ...UserFields
  }
  title
  pathId
  canonicalRealm {
    ...RealmCanonicalFields
  }
  bannerText
  bannerPhoto {
    ...PhotoFields
  }
  matrices {
    ...MatrixLiteFields
  }
}
    ${UserFieldsFragmentDoc}
${RealmCanonicalFieldsFragmentDoc}
${PhotoFieldsFragmentDoc}
${MatrixLiteFieldsFragmentDoc}`;
export const SuccessFieldsFragmentDoc = gql`
    fragment SuccessFields on Success {
  success
  message
}
    `;
export const GetNavDocument = gql`
    query GetNav($isContentEditor: Boolean = false) {
  realms {
    items {
      id
      pathId
      title
      bannerText
      bannerPhoto {
        ...PhotoFields
      }
      ... on Realm @include(if: $isContentEditor) {
        published
        created
        owner {
          id
          name
        }
      }
      zones {
        ...ZoneLiteFields
        ...ZoneAdminFields @include(if: $isContentEditor)
        matrices {
          ...MatrixLiteFields
          ...MatrixAdminFields @include(if: $isContentEditor)
        }
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}
${ZoneLiteFieldsFragmentDoc}
${ZoneAdminFieldsFragmentDoc}
${MatrixLiteFieldsFragmentDoc}
${MatrixAdminFieldsFragmentDoc}`;

/**
 * __useGetNavQuery__
 *
 * To run a query within a React component, call `useGetNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavQuery({
 *   variables: {
 *      isContentEditor: // value for 'isContentEditor'
 *   },
 * });
 */
export function useGetNavQuery(baseOptions?: Apollo.QueryHookOptions<GetNavQuery, GetNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNavQuery, GetNavQueryVariables>(GetNavDocument, options);
      }
export function useGetNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavQuery, GetNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNavQuery, GetNavQueryVariables>(GetNavDocument, options);
        }
// @ts-ignore
export function useGetNavSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNavQuery, GetNavQueryVariables>): Apollo.UseSuspenseQueryResult<GetNavQuery, GetNavQueryVariables>;
export function useGetNavSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNavQuery, GetNavQueryVariables>): Apollo.UseSuspenseQueryResult<GetNavQuery | undefined, GetNavQueryVariables>;
export function useGetNavSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNavQuery, GetNavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNavQuery, GetNavQueryVariables>(GetNavDocument, options);
        }
export type GetNavQueryHookResult = ReturnType<typeof useGetNavQuery>;
export type GetNavLazyQueryHookResult = ReturnType<typeof useGetNavLazyQuery>;
export type GetNavSuspenseQueryHookResult = ReturnType<typeof useGetNavSuspenseQuery>;
export type GetNavQueryResult = Apollo.QueryResult<GetNavQuery, GetNavQueryVariables>;
export const AnimationAddFramesDocument = gql`
    mutation AnimationAddFrames($id: Int!, $data: AnimationAddFramesInput!) {
  animationAddFrames(id: $id, data: $data) {
    ... on SuccessResponse {
      errors
      debug
      success {
        ...SuccessFields
      }
    }
  }
}
    ${SuccessFieldsFragmentDoc}`;
export type AnimationAddFramesMutationFn = Apollo.MutationFunction<AnimationAddFramesMutation, AnimationAddFramesMutationVariables>;

/**
 * __useAnimationAddFramesMutation__
 *
 * To run a mutation, you first call `useAnimationAddFramesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnimationAddFramesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [animationAddFramesMutation, { data, loading, error }] = useAnimationAddFramesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAnimationAddFramesMutation(baseOptions?: Apollo.MutationHookOptions<AnimationAddFramesMutation, AnimationAddFramesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnimationAddFramesMutation, AnimationAddFramesMutationVariables>(AnimationAddFramesDocument, options);
      }
export type AnimationAddFramesMutationHookResult = ReturnType<typeof useAnimationAddFramesMutation>;
export type AnimationAddFramesMutationResult = Apollo.MutationResult<AnimationAddFramesMutation>;
export type AnimationAddFramesMutationOptions = Apollo.BaseMutationOptions<AnimationAddFramesMutation, AnimationAddFramesMutationVariables>;
export const AnimationUpdateDocument = gql`
    mutation AnimationUpdate($id: Int!, $data: AnimationUpdateInput!) {
  animationUpdate(id: $id, data: $data) {
    ... on AnimationResponse {
      errors
      debug
      animation {
        ...AnimationFields
      }
    }
  }
}
    ${AnimationFieldsFragmentDoc}`;
export type AnimationUpdateMutationFn = Apollo.MutationFunction<AnimationUpdateMutation, AnimationUpdateMutationVariables>;

/**
 * __useAnimationUpdateMutation__
 *
 * To run a mutation, you first call `useAnimationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnimationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [animationUpdateMutation, { data, loading, error }] = useAnimationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAnimationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AnimationUpdateMutation, AnimationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnimationUpdateMutation, AnimationUpdateMutationVariables>(AnimationUpdateDocument, options);
      }
export type AnimationUpdateMutationHookResult = ReturnType<typeof useAnimationUpdateMutation>;
export type AnimationUpdateMutationResult = Apollo.MutationResult<AnimationUpdateMutation>;
export type AnimationUpdateMutationOptions = Apollo.BaseMutationOptions<AnimationUpdateMutation, AnimationUpdateMutationVariables>;
export const CreatePhotoDocument = gql`
    mutation CreatePhoto($caption: String, $imageFile: ImageFile, $copyright: Int!, $copyrightUrl: String) {
  createPhoto(
    data: {caption: $caption, imageFile: $imageFile, copyright: $copyright, copyrightUrl: $copyrightUrl}
  ) {
    ... on PhotoResponse {
      errors
      debug
      photo {
        ...PhotoFields
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;
export type CreatePhotoMutationFn = Apollo.MutationFunction<CreatePhotoMutation, CreatePhotoMutationVariables>;

/**
 * __useCreatePhotoMutation__
 *
 * To run a mutation, you first call `useCreatePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoMutation, { data, loading, error }] = useCreatePhotoMutation({
 *   variables: {
 *      caption: // value for 'caption'
 *      imageFile: // value for 'imageFile'
 *      copyright: // value for 'copyright'
 *      copyrightUrl: // value for 'copyrightUrl'
 *   },
 * });
 */
export function useCreatePhotoMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhotoMutation, CreatePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhotoMutation, CreatePhotoMutationVariables>(CreatePhotoDocument, options);
      }
export type CreatePhotoMutationHookResult = ReturnType<typeof useCreatePhotoMutation>;
export type CreatePhotoMutationResult = Apollo.MutationResult<CreatePhotoMutation>;
export type CreatePhotoMutationOptions = Apollo.BaseMutationOptions<CreatePhotoMutation, CreatePhotoMutationVariables>;
export const DeletePhotoDocument = gql`
    mutation DeletePhoto($id: Int!) {
  deletePhoto(id: $id) {
    ... on DeleteResponse {
      errors
      debug
      success {
        ...SuccessFields
      }
    }
  }
}
    ${SuccessFieldsFragmentDoc}`;
export type DeletePhotoMutationFn = Apollo.MutationFunction<DeletePhotoMutation, DeletePhotoMutationVariables>;

/**
 * __useDeletePhotoMutation__
 *
 * To run a mutation, you first call `useDeletePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoMutation, { data, loading, error }] = useDeletePhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeletePhotoMutation, DeletePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePhotoMutation, DeletePhotoMutationVariables>(DeletePhotoDocument, options);
      }
export type DeletePhotoMutationHookResult = ReturnType<typeof useDeletePhotoMutation>;
export type DeletePhotoMutationResult = Apollo.MutationResult<DeletePhotoMutation>;
export type DeletePhotoMutationOptions = Apollo.BaseMutationOptions<DeletePhotoMutation, DeletePhotoMutationVariables>;
export const UpdatePhotoDocument = gql`
    mutation UpdatePhoto($id: Int!, $caption: String!, $imageFile: ImageFile, $copyright: Int!, $copyrightUrl: String) {
  updatePhoto(
    id: $id
    data: {caption: $caption, imageFile: $imageFile, copyright: $copyright, copyrightUrl: $copyrightUrl}
  ) {
    ... on PhotoResponse {
      errors
      debug
      photo {
        ...PhotoFields
      }
    }
  }
}
    ${PhotoFieldsFragmentDoc}`;
export type UpdatePhotoMutationFn = Apollo.MutationFunction<UpdatePhotoMutation, UpdatePhotoMutationVariables>;

/**
 * __useUpdatePhotoMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoMutation, { data, loading, error }] = useUpdatePhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      caption: // value for 'caption'
 *      imageFile: // value for 'imageFile'
 *      copyright: // value for 'copyright'
 *      copyrightUrl: // value for 'copyrightUrl'
 *   },
 * });
 */
export function useUpdatePhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhotoMutation, UpdatePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhotoMutation, UpdatePhotoMutationVariables>(UpdatePhotoDocument, options);
      }
export type UpdatePhotoMutationHookResult = ReturnType<typeof useUpdatePhotoMutation>;
export type UpdatePhotoMutationResult = Apollo.MutationResult<UpdatePhotoMutation>;
export type UpdatePhotoMutationOptions = Apollo.BaseMutationOptions<UpdatePhotoMutation, UpdatePhotoMutationVariables>;
export const GetTextEditDocument = gql`
    query GetTextEdit($textId: Int!) {
  textEdit(id: $textId) {
    ...TextEditFields
  }
}
    ${TextEditFieldsFragmentDoc}`;

/**
 * __useGetTextEditQuery__
 *
 * To run a query within a React component, call `useGetTextEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTextEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTextEditQuery({
 *   variables: {
 *      textId: // value for 'textId'
 *   },
 * });
 */
export function useGetTextEditQuery(baseOptions: Apollo.QueryHookOptions<GetTextEditQuery, GetTextEditQueryVariables> & ({ variables: GetTextEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTextEditQuery, GetTextEditQueryVariables>(GetTextEditDocument, options);
      }
export function useGetTextEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTextEditQuery, GetTextEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTextEditQuery, GetTextEditQueryVariables>(GetTextEditDocument, options);
        }
// @ts-ignore
export function useGetTextEditSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTextEditQuery, GetTextEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetTextEditQuery, GetTextEditQueryVariables>;
export function useGetTextEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTextEditQuery, GetTextEditQueryVariables>): Apollo.UseSuspenseQueryResult<GetTextEditQuery | undefined, GetTextEditQueryVariables>;
export function useGetTextEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTextEditQuery, GetTextEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTextEditQuery, GetTextEditQueryVariables>(GetTextEditDocument, options);
        }
export type GetTextEditQueryHookResult = ReturnType<typeof useGetTextEditQuery>;
export type GetTextEditLazyQueryHookResult = ReturnType<typeof useGetTextEditLazyQuery>;
export type GetTextEditSuspenseQueryHookResult = ReturnType<typeof useGetTextEditSuspenseQuery>;
export type GetTextEditQueryResult = Apollo.QueryResult<GetTextEditQuery, GetTextEditQueryVariables>;
export const UpdateTextDocument = gql`
    mutation UpdateText($id: Int!, $adminTitle: String!, $adminNote: String, $text: String, $textJson: String) {
  updateText(
    id: $id
    data: {adminTitle: $adminTitle, adminNote: $adminNote, text: $text, textJson: $textJson}
  ) {
    ... on TextResponse {
      errors
      debug
      text {
        ...TextFields
      }
      textEdit {
        ...TextEditFields
      }
    }
  }
}
    ${TextFieldsFragmentDoc}
${TextEditFieldsFragmentDoc}`;
export type UpdateTextMutationFn = Apollo.MutationFunction<UpdateTextMutation, UpdateTextMutationVariables>;

/**
 * __useUpdateTextMutation__
 *
 * To run a mutation, you first call `useUpdateTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTextMutation, { data, loading, error }] = useUpdateTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adminTitle: // value for 'adminTitle'
 *      adminNote: // value for 'adminNote'
 *      text: // value for 'text'
 *      textJson: // value for 'textJson'
 *   },
 * });
 */
export function useUpdateTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTextMutation, UpdateTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTextMutation, UpdateTextMutationVariables>(UpdateTextDocument, options);
      }
export type UpdateTextMutationHookResult = ReturnType<typeof useUpdateTextMutation>;
export type UpdateTextMutationResult = Apollo.MutationResult<UpdateTextMutation>;
export type UpdateTextMutationOptions = Apollo.BaseMutationOptions<UpdateTextMutation, UpdateTextMutationVariables>;
export const SendContactEmailDocument = gql`
    mutation SendContactEmail($input: ContactInput!) {
  sendContactEmail(input: $input) {
    ... on ContactResponse {
      errors
      debug
      submission {
        success
        message
      }
    }
  }
}
    `;
export type SendContactEmailMutationFn = Apollo.MutationFunction<SendContactEmailMutation, SendContactEmailMutationVariables>;

/**
 * __useSendContactEmailMutation__
 *
 * To run a mutation, you first call `useSendContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactEmailMutation, { data, loading, error }] = useSendContactEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendContactEmailMutation, SendContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactEmailMutation, SendContactEmailMutationVariables>(SendContactEmailDocument, options);
      }
export type SendContactEmailMutationHookResult = ReturnType<typeof useSendContactEmailMutation>;
export type SendContactEmailMutationResult = Apollo.MutationResult<SendContactEmailMutation>;
export type SendContactEmailMutationOptions = Apollo.BaseMutationOptions<SendContactEmailMutation, SendContactEmailMutationVariables>;
export const GetClusterDocument = gql`
    query GetCluster($clusterId: Int!) {
  cluster(id: $clusterId) {
    ...ClusterFields
  }
}
    ${ClusterFieldsFragmentDoc}`;

/**
 * __useGetClusterQuery__
 *
 * To run a query within a React component, call `useGetClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterQuery(baseOptions: Apollo.QueryHookOptions<GetClusterQuery, GetClusterQueryVariables> & ({ variables: GetClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
      }
export function useGetClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
        }
// @ts-ignore
export function useGetClusterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>): Apollo.UseSuspenseQueryResult<GetClusterQuery, GetClusterQueryVariables>;
export function useGetClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>): Apollo.UseSuspenseQueryResult<GetClusterQuery | undefined, GetClusterQueryVariables>;
export function useGetClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClusterQuery, GetClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClusterQuery, GetClusterQueryVariables>(GetClusterDocument, options);
        }
export type GetClusterQueryHookResult = ReturnType<typeof useGetClusterQuery>;
export type GetClusterLazyQueryHookResult = ReturnType<typeof useGetClusterLazyQuery>;
export type GetClusterSuspenseQueryHookResult = ReturnType<typeof useGetClusterSuspenseQuery>;
export type GetClusterQueryResult = Apollo.QueryResult<GetClusterQuery, GetClusterQueryVariables>;
export const CreateClusterAnimationPanelDocument = gql`
    mutation CreateClusterAnimationPanel($clusterId: Int!, $data: AnimationPanelInput) {
  createClusterAnimationPanel(clusterId: $clusterId, data: $data) {
    ... on ClusterResponse {
      errors
      debug
      cluster {
        ...ClusterFields
      }
    }
  }
}
    ${ClusterFieldsFragmentDoc}`;
export type CreateClusterAnimationPanelMutationFn = Apollo.MutationFunction<CreateClusterAnimationPanelMutation, CreateClusterAnimationPanelMutationVariables>;

/**
 * __useCreateClusterAnimationPanelMutation__
 *
 * To run a mutation, you first call `useCreateClusterAnimationPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterAnimationPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterAnimationPanelMutation, { data, loading, error }] = useCreateClusterAnimationPanelMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClusterAnimationPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateClusterAnimationPanelMutation, CreateClusterAnimationPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClusterAnimationPanelMutation, CreateClusterAnimationPanelMutationVariables>(CreateClusterAnimationPanelDocument, options);
      }
export type CreateClusterAnimationPanelMutationHookResult = ReturnType<typeof useCreateClusterAnimationPanelMutation>;
export type CreateClusterAnimationPanelMutationResult = Apollo.MutationResult<CreateClusterAnimationPanelMutation>;
export type CreateClusterAnimationPanelMutationOptions = Apollo.BaseMutationOptions<CreateClusterAnimationPanelMutation, CreateClusterAnimationPanelMutationVariables>;
export const CreateClusterPhotoPanelDocument = gql`
    mutation CreateClusterPhotoPanel($clusterId: Int!, $delta: Int, $panelAdminTitle: String, $panelAdminNote: String, $x: Int, $y: Int, $z: Int, $photoCaption: String, $photoImageFile: ImageFile, $photoCopyright: Int, $photoCopyrightUrl: String) {
  createClusterPhotoPanel(
    clusterId: $clusterId
    data: {delta: $delta, panel: {adminTitle: $panelAdminTitle, adminNote: $panelAdminNote, x: $x, y: $y, z: $z}, photo: {caption: $photoCaption, imageFile: $photoImageFile, copyright: $photoCopyright, copyrightUrl: $photoCopyrightUrl}}
  ) {
    ... on ClusterResponse {
      errors
      debug
      cluster {
        ...ClusterFields
      }
    }
  }
}
    ${ClusterFieldsFragmentDoc}`;
export type CreateClusterPhotoPanelMutationFn = Apollo.MutationFunction<CreateClusterPhotoPanelMutation, CreateClusterPhotoPanelMutationVariables>;

/**
 * __useCreateClusterPhotoPanelMutation__
 *
 * To run a mutation, you first call `useCreateClusterPhotoPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterPhotoPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterPhotoPanelMutation, { data, loading, error }] = useCreateClusterPhotoPanelMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      delta: // value for 'delta'
 *      panelAdminTitle: // value for 'panelAdminTitle'
 *      panelAdminNote: // value for 'panelAdminNote'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      z: // value for 'z'
 *      photoCaption: // value for 'photoCaption'
 *      photoImageFile: // value for 'photoImageFile'
 *      photoCopyright: // value for 'photoCopyright'
 *      photoCopyrightUrl: // value for 'photoCopyrightUrl'
 *   },
 * });
 */
export function useCreateClusterPhotoPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateClusterPhotoPanelMutation, CreateClusterPhotoPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClusterPhotoPanelMutation, CreateClusterPhotoPanelMutationVariables>(CreateClusterPhotoPanelDocument, options);
      }
export type CreateClusterPhotoPanelMutationHookResult = ReturnType<typeof useCreateClusterPhotoPanelMutation>;
export type CreateClusterPhotoPanelMutationResult = Apollo.MutationResult<CreateClusterPhotoPanelMutation>;
export type CreateClusterPhotoPanelMutationOptions = Apollo.BaseMutationOptions<CreateClusterPhotoPanelMutation, CreateClusterPhotoPanelMutationVariables>;
export const CreateClusterTextPanelDocument = gql`
    mutation CreateClusterTextPanel($clusterId: Int!, $delta: Int, $panelAdminTitle: String, $panelAdminNote: String, $x: Int, $y: Int, $z: Int, $textAdminTitle: String, $textAdminNote: String, $text: String, $textJson: String) {
  createClusterTextPanel(
    clusterId: $clusterId
    data: {delta: $delta, panel: {adminTitle: $panelAdminTitle, adminNote: $panelAdminNote, x: $x, y: $y, z: $z}, text: {adminTitle: $textAdminTitle, adminNote: $textAdminNote, text: $text, textJson: $textJson}}
  ) {
    ... on ClusterResponse {
      errors
      debug
      cluster {
        ...ClusterFields
      }
    }
  }
}
    ${ClusterFieldsFragmentDoc}`;
export type CreateClusterTextPanelMutationFn = Apollo.MutationFunction<CreateClusterTextPanelMutation, CreateClusterTextPanelMutationVariables>;

/**
 * __useCreateClusterTextPanelMutation__
 *
 * To run a mutation, you first call `useCreateClusterTextPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterTextPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterTextPanelMutation, { data, loading, error }] = useCreateClusterTextPanelMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      delta: // value for 'delta'
 *      panelAdminTitle: // value for 'panelAdminTitle'
 *      panelAdminNote: // value for 'panelAdminNote'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      z: // value for 'z'
 *      textAdminTitle: // value for 'textAdminTitle'
 *      textAdminNote: // value for 'textAdminNote'
 *      text: // value for 'text'
 *      textJson: // value for 'textJson'
 *   },
 * });
 */
export function useCreateClusterTextPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateClusterTextPanelMutation, CreateClusterTextPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClusterTextPanelMutation, CreateClusterTextPanelMutationVariables>(CreateClusterTextPanelDocument, options);
      }
export type CreateClusterTextPanelMutationHookResult = ReturnType<typeof useCreateClusterTextPanelMutation>;
export type CreateClusterTextPanelMutationResult = Apollo.MutationResult<CreateClusterTextPanelMutation>;
export type CreateClusterTextPanelMutationOptions = Apollo.BaseMutationOptions<CreateClusterTextPanelMutation, CreateClusterTextPanelMutationVariables>;
export const UpdateClusterDocument = gql`
    mutation UpdateCluster($clusterId: Int!, $published: Boolean, $publishAll: Boolean, $adminTitle: String!, $adminNote: String, $shape: ClusterShape, $removePanelIds: [Int], $sortedPanelIds: [Int!]!) {
  updateCluster(
    clusterId: $clusterId
    data: {published: $published, publishAll: $publishAll, adminTitle: $adminTitle, adminNote: $adminNote, shape: $shape, removePanelIds: $removePanelIds, sortedPanelIds: $sortedPanelIds}
  ) {
    ... on ClusterResponse {
      errors
      debug
      cluster {
        ...ClusterFields
      }
    }
  }
}
    ${ClusterFieldsFragmentDoc}`;
export type UpdateClusterMutationFn = Apollo.MutationFunction<UpdateClusterMutation, UpdateClusterMutationVariables>;

/**
 * __useUpdateClusterMutation__
 *
 * To run a mutation, you first call `useUpdateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterMutation, { data, loading, error }] = useUpdateClusterMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      published: // value for 'published'
 *      publishAll: // value for 'publishAll'
 *      adminTitle: // value for 'adminTitle'
 *      adminNote: // value for 'adminNote'
 *      shape: // value for 'shape'
 *      removePanelIds: // value for 'removePanelIds'
 *      sortedPanelIds: // value for 'sortedPanelIds'
 *   },
 * });
 */
export function useUpdateClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterMutation, UpdateClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterMutation, UpdateClusterMutationVariables>(UpdateClusterDocument, options);
      }
export type UpdateClusterMutationHookResult = ReturnType<typeof useUpdateClusterMutation>;
export type UpdateClusterMutationResult = Apollo.MutationResult<UpdateClusterMutation>;
export type UpdateClusterMutationOptions = Apollo.BaseMutationOptions<UpdateClusterMutation, UpdateClusterMutationVariables>;
export const CreateMatrixClusterDocument = gql`
    mutation CreateMatrixCluster($matrixId: Int!, $data: CreateClusterInput!) {
  createMatrixCluster(matrixId: $matrixId, data: $data) {
    ... on MatrixResponse {
      errors
      debug
      matrix {
        ...MatrixFields
      }
    }
  }
}
    ${MatrixFieldsFragmentDoc}`;
export type CreateMatrixClusterMutationFn = Apollo.MutationFunction<CreateMatrixClusterMutation, CreateMatrixClusterMutationVariables>;

/**
 * __useCreateMatrixClusterMutation__
 *
 * To run a mutation, you first call `useCreateMatrixClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatrixClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatrixClusterMutation, { data, loading, error }] = useCreateMatrixClusterMutation({
 *   variables: {
 *      matrixId: // value for 'matrixId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMatrixClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatrixClusterMutation, CreateMatrixClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatrixClusterMutation, CreateMatrixClusterMutationVariables>(CreateMatrixClusterDocument, options);
      }
export type CreateMatrixClusterMutationHookResult = ReturnType<typeof useCreateMatrixClusterMutation>;
export type CreateMatrixClusterMutationResult = Apollo.MutationResult<CreateMatrixClusterMutation>;
export type CreateMatrixClusterMutationOptions = Apollo.BaseMutationOptions<CreateMatrixClusterMutation, CreateMatrixClusterMutationVariables>;
export const GetMatrixDocument = gql`
    query GetMatrix($matrixId: Int!) {
  matrix(id: $matrixId) {
    ...MatrixFields
  }
}
    ${MatrixFieldsFragmentDoc}`;

/**
 * __useGetMatrixQuery__
 *
 * To run a query within a React component, call `useGetMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatrixQuery({
 *   variables: {
 *      matrixId: // value for 'matrixId'
 *   },
 * });
 */
export function useGetMatrixQuery(baseOptions: Apollo.QueryHookOptions<GetMatrixQuery, GetMatrixQueryVariables> & ({ variables: GetMatrixQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatrixQuery, GetMatrixQueryVariables>(GetMatrixDocument, options);
      }
export function useGetMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatrixQuery, GetMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatrixQuery, GetMatrixQueryVariables>(GetMatrixDocument, options);
        }
// @ts-ignore
export function useGetMatrixSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMatrixQuery, GetMatrixQueryVariables>): Apollo.UseSuspenseQueryResult<GetMatrixQuery, GetMatrixQueryVariables>;
export function useGetMatrixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMatrixQuery, GetMatrixQueryVariables>): Apollo.UseSuspenseQueryResult<GetMatrixQuery | undefined, GetMatrixQueryVariables>;
export function useGetMatrixSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMatrixQuery, GetMatrixQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMatrixQuery, GetMatrixQueryVariables>(GetMatrixDocument, options);
        }
export type GetMatrixQueryHookResult = ReturnType<typeof useGetMatrixQuery>;
export type GetMatrixLazyQueryHookResult = ReturnType<typeof useGetMatrixLazyQuery>;
export type GetMatrixSuspenseQueryHookResult = ReturnType<typeof useGetMatrixSuspenseQuery>;
export type GetMatrixQueryResult = Apollo.QueryResult<GetMatrixQuery, GetMatrixQueryVariables>;
export const GetMatrixLiteDocument = gql`
    query GetMatrixLite($matrixId: Int!) {
  matrix(id: $matrixId) {
    ...MatrixLiteFields
  }
}
    ${MatrixLiteFieldsFragmentDoc}`;

/**
 * __useGetMatrixLiteQuery__
 *
 * To run a query within a React component, call `useGetMatrixLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatrixLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatrixLiteQuery({
 *   variables: {
 *      matrixId: // value for 'matrixId'
 *   },
 * });
 */
export function useGetMatrixLiteQuery(baseOptions: Apollo.QueryHookOptions<GetMatrixLiteQuery, GetMatrixLiteQueryVariables> & ({ variables: GetMatrixLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>(GetMatrixLiteDocument, options);
      }
export function useGetMatrixLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>(GetMatrixLiteDocument, options);
        }
// @ts-ignore
export function useGetMatrixLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>;
export function useGetMatrixLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetMatrixLiteQuery | undefined, GetMatrixLiteQueryVariables>;
export function useGetMatrixLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>(GetMatrixLiteDocument, options);
        }
export type GetMatrixLiteQueryHookResult = ReturnType<typeof useGetMatrixLiteQuery>;
export type GetMatrixLiteLazyQueryHookResult = ReturnType<typeof useGetMatrixLiteLazyQuery>;
export type GetMatrixLiteSuspenseQueryHookResult = ReturnType<typeof useGetMatrixLiteSuspenseQuery>;
export type GetMatrixLiteQueryResult = Apollo.QueryResult<GetMatrixLiteQuery, GetMatrixLiteQueryVariables>;
export const UpdateMatrixDocument = gql`
    mutation UpdateMatrix($matrixId: Int!, $data: MatrixInput!) {
  updateMatrix(matrixId: $matrixId, data: $data) {
    ... on MatrixResponse {
      errors
      debug
      matrix {
        ...MatrixFields
      }
    }
  }
}
    ${MatrixFieldsFragmentDoc}`;
export type UpdateMatrixMutationFn = Apollo.MutationFunction<UpdateMatrixMutation, UpdateMatrixMutationVariables>;

/**
 * __useUpdateMatrixMutation__
 *
 * To run a mutation, you first call `useUpdateMatrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatrixMutation, { data, loading, error }] = useUpdateMatrixMutation({
 *   variables: {
 *      matrixId: // value for 'matrixId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMatrixMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatrixMutation, UpdateMatrixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatrixMutation, UpdateMatrixMutationVariables>(UpdateMatrixDocument, options);
      }
export type UpdateMatrixMutationHookResult = ReturnType<typeof useUpdateMatrixMutation>;
export type UpdateMatrixMutationResult = Apollo.MutationResult<UpdateMatrixMutation>;
export type UpdateMatrixMutationOptions = Apollo.BaseMutationOptions<UpdateMatrixMutation, UpdateMatrixMutationVariables>;
export const UpdatePanelDocument = gql`
    mutation UpdatePanel($id: Int!, $published: Boolean, $adminTitle: String!, $adminNote: String, $x: Int, $y: Int, $z: Int) {
  updatePanel(
    id: $id
    data: {published: $published, adminTitle: $adminTitle, adminNote: $adminNote, x: $x, y: $y, z: $z}
  ) {
    ... on PanelResponse {
      errors
      debug
      panel {
        ...PanelFields
      }
    }
  }
}
    ${PanelFieldsFragmentDoc}`;
export type UpdatePanelMutationFn = Apollo.MutationFunction<UpdatePanelMutation, UpdatePanelMutationVariables>;

/**
 * __useUpdatePanelMutation__
 *
 * To run a mutation, you first call `useUpdatePanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePanelMutation, { data, loading, error }] = useUpdatePanelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      published: // value for 'published'
 *      adminTitle: // value for 'adminTitle'
 *      adminNote: // value for 'adminNote'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      z: // value for 'z'
 *   },
 * });
 */
export function useUpdatePanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePanelMutation, UpdatePanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePanelMutation, UpdatePanelMutationVariables>(UpdatePanelDocument, options);
      }
export type UpdatePanelMutationHookResult = ReturnType<typeof useUpdatePanelMutation>;
export type UpdatePanelMutationResult = Apollo.MutationResult<UpdatePanelMutation>;
export type UpdatePanelMutationOptions = Apollo.BaseMutationOptions<UpdatePanelMutation, UpdatePanelMutationVariables>;
export const CreateRealmZoneDocument = gql`
    mutation CreateRealmZone($realmId: Int!, $data: CreateZoneInput!) {
  createRealmZone(realmId: $realmId, data: $data) {
    ... on RealmResponse {
      errors
      debug
      realm {
        ...RealmFields
      }
    }
  }
}
    ${RealmFieldsFragmentDoc}`;
export type CreateRealmZoneMutationFn = Apollo.MutationFunction<CreateRealmZoneMutation, CreateRealmZoneMutationVariables>;

/**
 * __useCreateRealmZoneMutation__
 *
 * To run a mutation, you first call `useCreateRealmZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRealmZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRealmZoneMutation, { data, loading, error }] = useCreateRealmZoneMutation({
 *   variables: {
 *      realmId: // value for 'realmId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRealmZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateRealmZoneMutation, CreateRealmZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRealmZoneMutation, CreateRealmZoneMutationVariables>(CreateRealmZoneDocument, options);
      }
export type CreateRealmZoneMutationHookResult = ReturnType<typeof useCreateRealmZoneMutation>;
export type CreateRealmZoneMutationResult = Apollo.MutationResult<CreateRealmZoneMutation>;
export type CreateRealmZoneMutationOptions = Apollo.BaseMutationOptions<CreateRealmZoneMutation, CreateRealmZoneMutationVariables>;
export const GetRealmDocument = gql`
    query GetRealm($realmId: Int!) {
  realm(id: $realmId) {
    ...RealmFields
  }
}
    ${RealmFieldsFragmentDoc}`;

/**
 * __useGetRealmQuery__
 *
 * To run a query within a React component, call `useGetRealmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealmQuery({
 *   variables: {
 *      realmId: // value for 'realmId'
 *   },
 * });
 */
export function useGetRealmQuery(baseOptions: Apollo.QueryHookOptions<GetRealmQuery, GetRealmQueryVariables> & ({ variables: GetRealmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealmQuery, GetRealmQueryVariables>(GetRealmDocument, options);
      }
export function useGetRealmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealmQuery, GetRealmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealmQuery, GetRealmQueryVariables>(GetRealmDocument, options);
        }
// @ts-ignore
export function useGetRealmSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRealmQuery, GetRealmQueryVariables>): Apollo.UseSuspenseQueryResult<GetRealmQuery, GetRealmQueryVariables>;
export function useGetRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRealmQuery, GetRealmQueryVariables>): Apollo.UseSuspenseQueryResult<GetRealmQuery | undefined, GetRealmQueryVariables>;
export function useGetRealmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRealmQuery, GetRealmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRealmQuery, GetRealmQueryVariables>(GetRealmDocument, options);
        }
export type GetRealmQueryHookResult = ReturnType<typeof useGetRealmQuery>;
export type GetRealmLazyQueryHookResult = ReturnType<typeof useGetRealmLazyQuery>;
export type GetRealmSuspenseQueryHookResult = ReturnType<typeof useGetRealmSuspenseQuery>;
export type GetRealmQueryResult = Apollo.QueryResult<GetRealmQuery, GetRealmQueryVariables>;
export const UpdateRealmDocument = gql`
    mutation UpdateRealm($realmId: Int!, $data: RealmInput!) {
  updateRealm(realmId: $realmId, data: $data) {
    ... on RealmResponse {
      errors
      debug
      realm {
        ...RealmFields
      }
    }
  }
}
    ${RealmFieldsFragmentDoc}`;
export type UpdateRealmMutationFn = Apollo.MutationFunction<UpdateRealmMutation, UpdateRealmMutationVariables>;

/**
 * __useUpdateRealmMutation__
 *
 * To run a mutation, you first call `useUpdateRealmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRealmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRealmMutation, { data, loading, error }] = useUpdateRealmMutation({
 *   variables: {
 *      realmId: // value for 'realmId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRealmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRealmMutation, UpdateRealmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRealmMutation, UpdateRealmMutationVariables>(UpdateRealmDocument, options);
      }
export type UpdateRealmMutationHookResult = ReturnType<typeof useUpdateRealmMutation>;
export type UpdateRealmMutationResult = Apollo.MutationResult<UpdateRealmMutation>;
export type UpdateRealmMutationOptions = Apollo.BaseMutationOptions<UpdateRealmMutation, UpdateRealmMutationVariables>;
export const CreateZoneMatrixDocument = gql`
    mutation CreateZoneMatrix($zoneId: Int!, $data: CreateMatrixInput!) {
  createZoneMatrix(zoneId: $zoneId, data: $data) {
    ... on ZoneResponse {
      errors
      debug
      zone {
        ...ZoneFields
      }
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type CreateZoneMatrixMutationFn = Apollo.MutationFunction<CreateZoneMatrixMutation, CreateZoneMatrixMutationVariables>;

/**
 * __useCreateZoneMatrixMutation__
 *
 * To run a mutation, you first call `useCreateZoneMatrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneMatrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneMatrixMutation, { data, loading, error }] = useCreateZoneMatrixMutation({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateZoneMatrixMutation(baseOptions?: Apollo.MutationHookOptions<CreateZoneMatrixMutation, CreateZoneMatrixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateZoneMatrixMutation, CreateZoneMatrixMutationVariables>(CreateZoneMatrixDocument, options);
      }
export type CreateZoneMatrixMutationHookResult = ReturnType<typeof useCreateZoneMatrixMutation>;
export type CreateZoneMatrixMutationResult = Apollo.MutationResult<CreateZoneMatrixMutation>;
export type CreateZoneMatrixMutationOptions = Apollo.BaseMutationOptions<CreateZoneMatrixMutation, CreateZoneMatrixMutationVariables>;
export const UpdateZoneDocument = gql`
    mutation UpdateZone($zoneId: Int!, $data: ZoneInput!) {
  updateZone(zoneId: $zoneId, data: $data) {
    ... on ZoneResponse {
      errors
      debug
      zone {
        ...ZoneFields
      }
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type UpdateZoneMutationFn = Apollo.MutationFunction<UpdateZoneMutation, UpdateZoneMutationVariables>;

/**
 * __useUpdateZoneMutation__
 *
 * To run a mutation, you first call `useUpdateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneMutation, { data, loading, error }] = useUpdateZoneMutation({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneMutation, UpdateZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneMutation, UpdateZoneMutationVariables>(UpdateZoneDocument, options);
      }
export type UpdateZoneMutationHookResult = ReturnType<typeof useUpdateZoneMutation>;
export type UpdateZoneMutationResult = Apollo.MutationResult<UpdateZoneMutation>;
export type UpdateZoneMutationOptions = Apollo.BaseMutationOptions<UpdateZoneMutation, UpdateZoneMutationVariables>;
export const GetZoneDocument = gql`
    query GetZone($zoneId: Int!) {
  zone(id: $zoneId) {
    ...ZoneFields
  }
}
    ${ZoneFieldsFragmentDoc}`;

/**
 * __useGetZoneQuery__
 *
 * To run a query within a React component, call `useGetZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetZoneQuery(baseOptions: Apollo.QueryHookOptions<GetZoneQuery, GetZoneQueryVariables> & ({ variables: GetZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
      }
export function useGetZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
        }
// @ts-ignore
export function useGetZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetZoneQuery, GetZoneQueryVariables>;
export function useGetZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>): Apollo.UseSuspenseQueryResult<GetZoneQuery | undefined, GetZoneQueryVariables>;
export function useGetZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZoneQuery, GetZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZoneQuery, GetZoneQueryVariables>(GetZoneDocument, options);
        }
export type GetZoneQueryHookResult = ReturnType<typeof useGetZoneQuery>;
export type GetZoneLazyQueryHookResult = ReturnType<typeof useGetZoneLazyQuery>;
export type GetZoneSuspenseQueryHookResult = ReturnType<typeof useGetZoneSuspenseQuery>;
export type GetZoneQueryResult = Apollo.QueryResult<GetZoneQuery, GetZoneQueryVariables>;
export const GetZoneLiteDocument = gql`
    query GetZoneLite($zoneId: Int!) {
  zone(id: $zoneId) {
    ...ZoneLiteFields
  }
}
    ${ZoneLiteFieldsFragmentDoc}`;

/**
 * __useGetZoneLiteQuery__
 *
 * To run a query within a React component, call `useGetZoneLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneLiteQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetZoneLiteQuery(baseOptions: Apollo.QueryHookOptions<GetZoneLiteQuery, GetZoneLiteQueryVariables> & ({ variables: GetZoneLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneLiteQuery, GetZoneLiteQueryVariables>(GetZoneLiteDocument, options);
      }
export function useGetZoneLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneLiteQuery, GetZoneLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneLiteQuery, GetZoneLiteQueryVariables>(GetZoneLiteDocument, options);
        }
// @ts-ignore
export function useGetZoneLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetZoneLiteQuery, GetZoneLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetZoneLiteQuery, GetZoneLiteQueryVariables>;
export function useGetZoneLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZoneLiteQuery, GetZoneLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetZoneLiteQuery | undefined, GetZoneLiteQueryVariables>;
export function useGetZoneLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetZoneLiteQuery, GetZoneLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetZoneLiteQuery, GetZoneLiteQueryVariables>(GetZoneLiteDocument, options);
        }
export type GetZoneLiteQueryHookResult = ReturnType<typeof useGetZoneLiteQuery>;
export type GetZoneLiteLazyQueryHookResult = ReturnType<typeof useGetZoneLiteLazyQuery>;
export type GetZoneLiteSuspenseQueryHookResult = ReturnType<typeof useGetZoneLiteSuspenseQuery>;
export type GetZoneLiteQueryResult = Apollo.QueryResult<GetZoneLiteQuery, GetZoneLiteQueryVariables>;
export const GetUserCurrentDocument = gql`
    query GetUserCurrent {
  userCurrent {
    id
    uuid
    name
    email
    created
    updated
    roles
  }
}
    `;

/**
 * __useGetUserCurrentQuery__
 *
 * To run a query within a React component, call `useGetUserCurrentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCurrentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCurrentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCurrentQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCurrentQuery, GetUserCurrentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCurrentQuery, GetUserCurrentQueryVariables>(GetUserCurrentDocument, options);
      }
export function useGetUserCurrentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCurrentQuery, GetUserCurrentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCurrentQuery, GetUserCurrentQueryVariables>(GetUserCurrentDocument, options);
        }
// @ts-ignore
export function useGetUserCurrentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserCurrentQuery, GetUserCurrentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCurrentQuery, GetUserCurrentQueryVariables>;
export function useGetUserCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCurrentQuery, GetUserCurrentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserCurrentQuery | undefined, GetUserCurrentQueryVariables>;
export function useGetUserCurrentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCurrentQuery, GetUserCurrentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCurrentQuery, GetUserCurrentQueryVariables>(GetUserCurrentDocument, options);
        }
export type GetUserCurrentQueryHookResult = ReturnType<typeof useGetUserCurrentQuery>;
export type GetUserCurrentLazyQueryHookResult = ReturnType<typeof useGetUserCurrentLazyQuery>;
export type GetUserCurrentSuspenseQueryHookResult = ReturnType<typeof useGetUserCurrentSuspenseQuery>;
export type GetUserCurrentQueryResult = Apollo.QueryResult<GetUserCurrentQuery, GetUserCurrentQueryVariables>;
export const CreateCopyrightDocument = gql`
    mutation CreateCopyright($name: String, $copyrightType: CopyrightType, $copyrightUrl: String) {
  createCopyright(
    data: {name: $name, copyrightType: $copyrightType, copyrightUrl: $copyrightUrl}
  ) {
    ... on CopyrightResponse {
      errors
      debug
      copyright {
        ...CopyrightFields
      }
    }
  }
}
    ${CopyrightFieldsFragmentDoc}`;
export type CreateCopyrightMutationFn = Apollo.MutationFunction<CreateCopyrightMutation, CreateCopyrightMutationVariables>;

/**
 * __useCreateCopyrightMutation__
 *
 * To run a mutation, you first call `useCreateCopyrightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCopyrightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCopyrightMutation, { data, loading, error }] = useCreateCopyrightMutation({
 *   variables: {
 *      name: // value for 'name'
 *      copyrightType: // value for 'copyrightType'
 *      copyrightUrl: // value for 'copyrightUrl'
 *   },
 * });
 */
export function useCreateCopyrightMutation(baseOptions?: Apollo.MutationHookOptions<CreateCopyrightMutation, CreateCopyrightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCopyrightMutation, CreateCopyrightMutationVariables>(CreateCopyrightDocument, options);
      }
export type CreateCopyrightMutationHookResult = ReturnType<typeof useCreateCopyrightMutation>;
export type CreateCopyrightMutationResult = Apollo.MutationResult<CreateCopyrightMutation>;
export type CreateCopyrightMutationOptions = Apollo.BaseMutationOptions<CreateCopyrightMutation, CreateCopyrightMutationVariables>;
export const GetCopyrightsDocument = gql`
    query GetCopyrights {
  copyrights {
    total
    items {
      ...CopyrightFields
    }
  }
}
    ${CopyrightFieldsFragmentDoc}`;

/**
 * __useGetCopyrightsQuery__
 *
 * To run a query within a React component, call `useGetCopyrightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCopyrightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCopyrightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCopyrightsQuery(baseOptions?: Apollo.QueryHookOptions<GetCopyrightsQuery, GetCopyrightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCopyrightsQuery, GetCopyrightsQueryVariables>(GetCopyrightsDocument, options);
      }
export function useGetCopyrightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCopyrightsQuery, GetCopyrightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCopyrightsQuery, GetCopyrightsQueryVariables>(GetCopyrightsDocument, options);
        }
// @ts-ignore
export function useGetCopyrightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCopyrightsQuery, GetCopyrightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCopyrightsQuery, GetCopyrightsQueryVariables>;
export function useGetCopyrightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCopyrightsQuery, GetCopyrightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCopyrightsQuery | undefined, GetCopyrightsQueryVariables>;
export function useGetCopyrightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCopyrightsQuery, GetCopyrightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCopyrightsQuery, GetCopyrightsQueryVariables>(GetCopyrightsDocument, options);
        }
export type GetCopyrightsQueryHookResult = ReturnType<typeof useGetCopyrightsQuery>;
export type GetCopyrightsLazyQueryHookResult = ReturnType<typeof useGetCopyrightsLazyQuery>;
export type GetCopyrightsSuspenseQueryHookResult = ReturnType<typeof useGetCopyrightsSuspenseQuery>;
export type GetCopyrightsQueryResult = Apollo.QueryResult<GetCopyrightsQuery, GetCopyrightsQueryVariables>;
export const GetSitemapRoutesDocument = gql`
    query GetSitemapRoutes {
  globalLastmod
  realms {
    items {
      id
      title
      pathId
      lastmod
      zones {
        id
        title
        pathId
        lastmod
        matrices {
          id
          title
          pathId
          lastmod
        }
      }
    }
  }
  home: matrix(id: 1100) {
    lastmod
  }
}
    `;

/**
 * __useGetSitemapRoutesQuery__
 *
 * To run a query within a React component, call `useGetSitemapRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitemapRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitemapRoutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitemapRoutesQuery(baseOptions?: Apollo.QueryHookOptions<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>(GetSitemapRoutesDocument, options);
      }
export function useGetSitemapRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>(GetSitemapRoutesDocument, options);
        }
// @ts-ignore
export function useGetSitemapRoutesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>;
export function useGetSitemapRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSitemapRoutesQuery | undefined, GetSitemapRoutesQueryVariables>;
export function useGetSitemapRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>(GetSitemapRoutesDocument, options);
        }
export type GetSitemapRoutesQueryHookResult = ReturnType<typeof useGetSitemapRoutesQuery>;
export type GetSitemapRoutesLazyQueryHookResult = ReturnType<typeof useGetSitemapRoutesLazyQuery>;
export type GetSitemapRoutesSuspenseQueryHookResult = ReturnType<typeof useGetSitemapRoutesSuspenseQuery>;
export type GetSitemapRoutesQueryResult = Apollo.QueryResult<GetSitemapRoutesQuery, GetSitemapRoutesQueryVariables>;